export const DIALOG_WIDTH = 200;
export const TABLE_HEAD_HEIGHT = 57;
export const HEADER_WIDTH = '10vh';
export const REPORT_PAGE_NAVIGATION = '40px';
export const TABLE_HEADER_WIDTH = '9vh';
export const MARGIN = '3vh';
